import { withInstall } from '@hd-front-end/utils'
import Countdown from './src/countdown.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElCountdown: SFCWithInstall<typeof Countdown> =
  withInstall(Countdown)
export default ElCountdown

export * from './src/countdown'
